export default class FormModifPrefill {
    constructor(el) {
        this.form = el;
        this.load();
    }

    load() {
        jQuery.ajax({
            url:  hwc_vars.ajax_url,
            type: 'post',
            data: { action: 'hwc_load_form587_prefill' },
            success: (response) => {
                if (!response.success) return;
                this.fill(response.data);
            },
        });
    }

    fill(d) {
        this.setVal('[name="wpforms[fields][34]"]', d.edit_url);
        this.setVal('[name="wpforms[fields][8]"]',  d.web_site);
        this.setVal('[name="wpforms[fields][16]"]', d.desc);
        this.setVal('[name="wpforms[fields][33]"]', d.mail);

        // Adresse principale
        this.setVal('[name="wpforms[fields][18]"]', d.address);
        this.setVal('[name="wpforms[fields][19]"]', d.address_postcode);
        this.setVal('[name="wpforms[fields][20]"]', d.address_city);
        this.setVal('[name="wpforms[fields][23]"]', d.lat);
        this.setVal('[name="wpforms[fields][24]"]', d.lng);

        // Checkbox "même adresse" (#30) : cochée si PAS de factu différente
        this.setCheck('[name="wpforms[fields][30]"]', !d.factu_diff);

        // Adresse facturation
        if (d.factu_diff) {
            this.setVal('[name="wpforms[fields][26]"]', d.address_factu.address);
            this.setVal('[name="wpforms[fields][27]"]', d.address_factu.address_city);
            this.setVal('[name="wpforms[fields][28]"]', d.address_factu.address_postcode);
        }
    }

    setVal(selector, value) {
        const el = this.form.querySelector(selector);
        if (el) el.value = value ?? '';
    }

    setCheck(selector, checked) {
        const el = this.form.querySelector(selector);
        if (el) {
            el.checked = checked;
            el.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}
